import React from 'react';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Card, CardContent } from '@/Components/ui/card';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';

export default function StatsCards() {
  return (
    <Stack spacing="lg" className="mt-[105px] px-2">
      <Inline spacing="md" className="gap-5">
        <Stack spacing="md" className="w-1/2">
          <Card className="rounded-lg border border-muted-foreground/30 min-h-[182px] p-[13px_51px_13px_31px] flex flex-col justify-center">
            <CardContent className="p-0">
              <Heading level="h2" className="text-[25px] font-semibold tracking-wide mb-0 p-2.5">
                Combined Valuation
              </Heading>
              <Inline spacing="sm" align="end" className="mt-[37px]">
                <Text size="4xl" className="text-[35px] font-semibold tracking-wide">
                  $40.5
                </Text>
                <Text size="xl" className="text-xl tracking-wide ml-2.5">
                  trillion
                </Text>
              </Inline>
            </CardContent>
          </Card>
          
          <Card className="rounded-lg border border-muted-foreground/30 min-h-[182px] p-[13px_51px_13px_31px] flex flex-col justify-center mt-[21px]">
            <CardContent className="p-0">
              <Heading level="h2" className="text-[25px] font-semibold tracking-wide mb-0 p-2.5">
                Tech Co's {'>'}$1B
              </Heading>
              <Text size="4xl" className="text-[35px] font-semibold tracking-wide mt-[37px]">
                1,928
              </Text>
            </CardContent>
          </Card>
          
          <Card className="rounded-lg border border-muted-foreground/30 min-h-[182px] p-[13px_51px_13px_31px] flex flex-col justify-center mt-[21px]">
            <CardContent className="p-0">
              <Heading level="h2" className="text-[25px] font-semibold tracking-wide mb-0 p-2.5">
                Public Tech Co's {'>'}$1B
              </Heading>
              <Text size="4xl" className="text-[35px] font-semibold tracking-wide mt-[37px]">
                1,928
              </Text>
            </CardContent>
          </Card>
          
          <Card className="rounded-lg border border-muted-foreground/30 min-h-[182px] p-[13px_51px_13px_31px] flex flex-col justify-center mt-[21px]">
            <CardContent className="p-0">
              <Heading level="h2" className="text-[25px] font-semibold tracking-wide mb-0 p-2.5">
                Open Jobs at Tech Co's
              </Heading>
              <Text size="4xl" className="text-[35px] font-semibold tracking-wide mt-[37px]">
                1,928
              </Text>
            </CardContent>
          </Card>
        </Stack>
        
        <Stack spacing="md" className="w-1/2">
          <Card className="rounded-lg border border-muted-foreground/30 min-h-[182px] p-[13px_51px_13px_31px] flex flex-col justify-center">
            <CardContent className="p-0">
              <Heading level="h2" className="text-[25px] font-semibold tracking-wide mb-0 p-2.5">
                Private Tech Co's {'>'}$1B
              </Heading>
              <Text size="4xl" className="text-[35px] font-semibold tracking-wide mt-[37px]">
                1,928
              </Text>
            </CardContent>
          </Card>
        </Stack>
      </Inline>
    </Stack>
  );
}
